import { render } from "./setLocationComponent.vue?vue&type=template&id=104af5be&scoped=true"
import script from "./setLocationComponent.vue?vue&type=script&lang=js"
export * from "./setLocationComponent.vue?vue&type=script&lang=js"

import "./setLocationComponent.vue?vue&type=style&index=0&id=104af5be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104af5be"]])

export default __exports__